module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/8ft-mobile-2f6d21ada76170b9207358b092f87ed2.png";